export default __webpack_public_path__ + "static/media/preloader.3c64ce44.gif";